import { FAVORITE } from 'utils/constants/casino/casino-element-names';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { isMobile } from 'utils/is-mobile';
import { NewCasinoCategory } from 'interfaces/new-casino';

export const leftSideBarCasinoMain = (): boolean => {
  if (isMobile()) {
    return false;
  }

  const matchCasinoUrl = new RegExp(`${SpringConfigs.PAGE_URLS.casino}/`);

  return (
    !!window.location.href.match(matchCasinoUrl) &&
    SpringConfigs.LEFT_SIDE_BAR &&
    SpringConfigs.LEFT_SIDE_BAR_CASINO
  );
};

export const recentPlayedParams = (catId?: number): { category_id: number } => {
  const params = { category_id: catId || 0 };

  return params;
};

export const isShowGamesCountBadge = (
  category: NewCasinoCategory,
  gamesCount?: boolean
): boolean => {
  return !!(
    (!!+category.games_count && !!gamesCount) ||
    (category.id === FAVORITE && +category.games_count)
  );
};

export const SELECT_PROVIDERS_TYPE = 'providers';

export const clearCasinoPopupQuery = (): URLSearchParams => {
  const querySearch = new URLSearchParams(window.location.search);

  querySearch.delete('mode');
  querySearch.delete('login');
  querySearch.delete('register');
  querySearch.delete('forgot-password');
  querySearch.delete('gameId');
  querySearch.delete('preview');
  querySearch.delete('profile');
  querySearch.delete('accounts');
  querySearch.delete('settings');

  return querySearch;
};
